import script from "./SectionReviews.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionReviews.vue?vue&type=script&setup=true&lang=js"

import "./SectionReviews.vue?vue&type=style&index=0&id=691af02e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-691af02e"]])

export default __exports__